module.exports = __webpack_public_path__ + "img/03.3160408e.png";